import React from 'react';
import { useTranslation } from 'react-i18next';
import { useBranding } from 'modules/Common/hooks/useBranding';

const PlanEndedState = () => {
  const { t } = useTranslation('common');
  const { supportEmail } = useBranding();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 text-center">
      <div className="max-w-md">
        <h1 className="mb-3 text-2xl font-semibold text-gray-900">
          {t('common:planEnded.title', 'Your plan has ended')}
        </h1>
        <p className="mb-6 text-sm leading-6 text-gray-600">
          {t('common:planEnded.body', 'Contact support to renew your plan.')}
        </p>
        {supportEmail && (
          <a
            href={`mailto:${supportEmail}`}
            className="inline-block rounded-md bg-primaryColor px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-primaryColor-dark"
          >
            {t('common:planEnded.contact', 'Contact support')}
          </a>
        )}
      </div>
    </div>
  );
};

export default PlanEndedState;
